import { render, staticRenderFns } from "./B2bForm.vue?vue&type=template&id=45f675cd&scoped=true&"
import script from "./B2bForm.vue?vue&type=script&lang=js&"
export * from "./B2bForm.vue?vue&type=script&lang=js&"
import style0 from "./B2bForm.vue?vue&type=style&index=0&id=45f675cd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f675cd",
  null
  
)

export default component.exports